import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getAttributeList as getAttributeListApi,
    getAttributeSearch as getAttributeSearchApi,
    addAttributeList as addAttributeListApi,
    updateAttributeList as updateAttributeListApi,
    deleteAttributeList as deleteAttributeListApi
} from "../../helpers/helper";
import { toast } from "react-toastify";

export const getAttributeList = createAsyncThunk("Attribute/getAttributeList", async () => {
    try {
        const response = await getAttributeListApi();
        return response;
    } catch (error) {
        return error;
    }
});
export const getAttributeSearch = createAsyncThunk("Attribute/getAttributeSearch", async (searchData:any) => {
    try {
        const response = await getAttributeSearchApi(searchData);
        return response;
    } catch (error) {
        return error;
    }
});

export const addAttributeList = createAsyncThunk("Attribute/addAttributeList", async (category: any) => {
    try {
        const response = addAttributeListApi(category);
        const data = await response;
        toast.success("Attribute Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Attribute Added Failed", { autoClose: 2000 });
        return error;
    }
});

export const updateAttributeList = createAsyncThunk("Attribute/update", async (dataArr: any) => {
    try {
        const response = updateAttributeListApi(dataArr);
        const data = await response;
        toast.success("Attribute Updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Attribute Updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteAttributeList = createAsyncThunk("Attribute/deleteAttributeList", async (categoryId: any) => {
    try {
        const response = deleteAttributeListApi(categoryId);
        console.log(response);
        toast.success("Attribute Deleted Successfully", { autoClose: 2000 });
        return categoryId;
    } catch (error) {
        toast.error("Attribute Deleted Failed", { autoClose: 2000 });
        return error;
    }
})
